import { render } from "./CV.vue?vue&type=template&id=18b2c366&scoped=true"
const script = {}

import "./CV.vue?vue&type=style&index=0&id=18b2c366&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18b2c366"

export default script